export const france = require('./svg/france.svg');
export const sverige = require('./svg/sverige.svg');
export const defaultLogo = require('./svg/default.svg');
